import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { DesktopNav } from "./DesktopNav";
import { MobileNav } from "./MobileNav";
import { CtaLink } from "./Button";
import { Logo } from "./Logo";
import { primaryCta, signInCta } from "@/config/site";
import "./SiteHeader.css";

export function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const toggleRef = useRef<HTMLButtonElement>(null);

  return (
    <header className="site-header">
      <div className="container site-header-inner">
        <Link to="/" aria-label="Devory home" className="site-header-brand">
          <Logo />
        </Link>
        <DesktopNav />
        <div className="site-header-actions">
          <CtaLink to={signInCta.path} variant="ghost" className="site-header-signin">
            {signInCta.label}
          </CtaLink>
          <CtaLink to={primaryCta.path} variant="primary" className="site-header-cta">
            {primaryCta.label}
          </CtaLink>
          <button
            type="button"
            className="site-header-menu-toggle"
            aria-expanded={menuOpen}
            aria-haspopup="dialog"
            ref={toggleRef}
            onClick={() => setMenuOpen(true)}
          >
            <span aria-hidden="true" className="site-header-menu-icon" />
            <span className="visually-hidden">Open menu</span>
          </button>
        </div>
      </div>
      <MobileNav open={menuOpen} onClose={() => setMenuOpen(false)} triggerRef={toggleRef} />
    </header>
  );
}
